// When buying I need to set the wallet to send the stable coin to.

import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { usePageStateStore } from "@/reducers";
import { WidgetLayout } from "../WidgetLayout";
import { AddWallet } from "./AddWallet";
import { TransactionInstructions } from "./TransactionInstructions";
import { DarkModeMenu } from "@/panels/signup/DarkmodeSignUpPanel";

enum BuyPageState {
  ADD_WALLET = "ADD_WALLET",
  SHOW_SUMMARY = "SHOW SUMMARY",
}

export const Buy = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const parent = searchParams.get("parent");

  const [wallet, setWallet] = useState(sessionStorage.getItem("walletAddress") || "");
  const [buyState, setBuyState] = useState(BuyPageState.ADD_WALLET);
  const [tx_id, setTxId] = [
    usePageStateStore.use.tx_id(),
    usePageStateStore.use.setTxId(),
  ];
  const [, setLoading] = useState(false);

  const confirmWallet = (txnId: string) => {
    setTxId(txnId);
    setBuyState(BuyPageState.SHOW_SUMMARY);
    navigate(`/status?id=${txnId}`);
  };

  return (
    <WidgetLayout showInteracLabel={false} showPoweredByLabel={true}>
      <div className="mt-20" data-testid="btn-transaction-container">
        {window.self === window.top && parent !== "landing" && (
          <div className="absolute top-10 right-0" data-testid="btn-dark-mode-container">
            <DarkModeMenu showSignOutButton={true} />
          </div>
        )}

        {buyState === BuyPageState.ADD_WALLET && (
          <AddWallet
            wallet={wallet}
            onSetWallet={setWallet}
            onSubmitSuccess={confirmWallet}
            setLoading={setLoading}
            data-testid="btn-add-wallet"
          />
        )}
        {buyState === BuyPageState.SHOW_SUMMARY && (
          <TransactionInstructions 
            orderId={tx_id} 
            wallet={wallet} 
            data-testid="btn-transaction-instructions"
          />
        )}
      </div>
    </WidgetLayout>
  );
};

/* 
 * Code Improvement Suggestions:
 * 
 * 1. Consider using an enum for page states instead of string literals
 * 2. Add error handling for failed transactions
 * 3. Loading state should be more robustly managed
 * 4. Navigation logic could be extracted to a custom hook
 * 5. The component should handle query parameter validation
 * 6. Consider adding a return button or cancel option
 * 7. Parent detection logic could be moved to a utility function
 * 8. State management could be improved with useReducer for complex state transitions
 */
